import React, { SVGProps } from "react";

export default function SupExplore(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 17C13.866 17 17 13.866 17 10C17 8.37751 16.448 6.88395 15.5215 5.69687L13.2291 13.2291L5.69687 15.5215C6.88395 16.448 8.37751 17 10 17ZM4.47845 14.3031L6.77088 6.77088L14.3031 4.47845C13.1161 3.552 11.6225 3 10 3C6.13401 3 3 6.13401 3 10C3 11.6225 3.552 13.1161 4.47845 14.3031ZM7.57227 7.57227L14.552 5.448L12.4277 12.4277L5.448 14.552L7.57227 7.57227Z"
        fill="currentColor"
      />
    </svg>
  );
}
